import { useSearch } from "@tanstack/react-router";
import { Route } from "@/routes/__root";
import MandateManagementDialog from "./components/mandates-dialog";

const Dialogs = () => {
  const search = useSearch({
    from: Route.id,
  });

  const isMandateDialogOpen = search.modal === "mandate";

  return isMandateDialogOpen ? <MandateManagementDialog /> : null;
};

export { Dialogs };
